module.exports = __webpack_public_path__ + "media/images/law_sara_lg-ecbfbd06b47c5e78252acec373946e43.svg";